<template>
    <div class="header">
        <div class="container-fluid">
            <!-- Hearer  -->
            <div class="mt-4">
                <div class="card">
                    <div class="card-body">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item fw-bolder">Role Management</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <!-- Card  -->
            <div class="card mt-5">
                <div class="card-header">
                    <!-- Title -->
                    <h4 class="card-header-title">Role Management</h4>
                    <!-- Button -->
                    <b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true">
                        <span class="fe fe-user-check mr-2"></span>
                        Assign User
                    </b-button>
                </div>
                <div class="d-flex justify-content-end mb-3 mt-3 mr-3">
                    <label class="align-self-center mb-0 mr-3">Search</label>
                    <b-form-input v-model="body.search" class="w-auto" placeholder="Type Here..." @change="getList()">
                    </b-form-input>
                </div>
                <vue-good-table :line-numbers="true" :columns="columns" :rows="list.data" :sort-options="{
                    enabled: true,
                    }" :total-rows="list.totalPages" :pagination-options="{
                    enabled: true,
                    mode: 'pages',
                    position: 'bottom',
                    perPage: body.pageSize,
                    perPageDropdown: [10, 50, 100],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page',
                    allLabel: 'All',
                    }" style-class="vgt-table border-0 table" @on-page-change="onPageChange"
                    @on-per-page-change="onPageChange" @on-sort-change="onSortChange">
                    <!-- Loading -->
                    <div slot="emptystate" class="text-center font-size-14">
                        No data available
                    </div>
                    <!-- Custom Rows -->
                    <template slot="table-row" slot-scope="props">
                        <!-- Table Action -->
                        <span v-if="props.column.field == 'action'">
                            <b-button class="no-wrap btn-pill" variant="warning" size="sm"
                                @click="updateData(props.row)">
                                <span class="fe fe-edit"></span>
                            </b-button>
                            <b-button class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                                @click="deleteData(props.row.id)">
                                <span class="fe fe-trash-2"></span>
                            </b-button>
                        </span>
                    </template>
                    <template slot="pagination-bottom" slot-scope="props">
                        <div class="d-flex justify-content-end">
                            <div>
                                <b-pagination :value="1" :total-rows="list.totalItems" :per-page="body.pageSize"
                                    first-number last-number align="right" prev-class="prev-item" next-class="next-item"
                                    class="mr-3 mb-4 mt-0"
                                    @input=" (value) => props.pageChanged({ currentPage: value })">
                                </b-pagination>
                            </div>
                        </div>
                    </template>
                </vue-good-table>
            </div>

            <!-- Modal -->
            <b-modal id="modal-1" hide-footer title="Role Management Form">
                <form @submit.prevent="saveAdd()" v-if="isAdd === true">
                    <div class="form-group">
                        <label>Employee Name <span class="text-danger">*</span></label>
                        <v-select v-model="modalCreate.nik" :options="listUser" label="fullname" :reduce="(e) => e.nik"
                            v-validate="'required'" name="Employee Name" />
                        <span class="text-sm text-danger"
                            v-show="errors.has('Employee Name')">{{ errors.first("Employee Name") }}</span>
                    </div>
                    <div class="form-group">
                        <label>Role <span class="text-danger">*</span></label>
                        <v-select v-model="modalCreate.role_id" :options="roles.data" label="roles_name"
                            :reduce="(e) => e.id" v-validate="'required'" name="Role" />
                        <span class="text-sm text-danger" v-show="errors.has('Role')">{{
                errors.first("Role")
              }}</span>
                    </div>
                    <div class="form-group">
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
                            v-if="isLoading == false">
                            Save
                        </button>
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button"
                            disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>

                <form @submit.prevent="saveUpdate()" v-else>
                    <div class="form-group">
                        <label>Employee Name <span class="text-danger">*</span></label>
                        <v-select v-model="modalUpdate.nik" disabled :options="listUser" label="fullname" :reduce="(e) => e.nik"
                            v-validate="'required'" name="Employee Name" />
                        <span class="text-sm text-danger"
                            v-show="errors.has('Employee Name')">{{ errors.first("Employee Name") }}</span>
                    </div>
                    <div class="form-group">
                        <label>Role <span class="text-danger">*</span></label>
                        <v-select v-model="modalUpdate.role_id" :options="roles.data" label="roles_name"
                            :reduce="(e) => e.id" v-validate="'required'" name="Role" />
                        <span class="text-sm text-danger" v-show="errors.has('Role')">{{
                errors.first("Role")
              }}</span>
                    </div>
                    <div class="form-group">
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="submit"
                            v-if="isLoading == false">
                            Save
                        </button>
                        <button style="margin-left: auto; float: right" class="mt-4 btn btn-primary" type="button"
                            disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GentaGendis",
        computed: {
            list() {
                return this.$store.getters["role/listData"];
            },
            roles() {
                return this.$store.getters["role/roles"];
            },
            listUser() {
                return this.$store.getters["role/listUser"];
            },
        },
        data() {
            return {
                body: {
                    page: 1,
                    pageSize: 10,
                    search: "",
                    field: "",
                    order: ""
                },
                modalCreate: {
                    nik: "",
                    role_id: "",
                },
                modalUpdate: {
                    nik: "",
                    role_id: "",
                },
                id: "",
                isAdd: true,
                isLoading: false,
                columns: [{
                        label: "Employee Name",
                        field: "user.fullname",
                        thClass: "table-header no-wrap text-muted font-weight-bold",
                        tdClass: "no-wrap color-secondary align-middle",
                    },
                    {
                        label: "Role",
                        field: "roles.roles_name",
                        thClass: "table-header no-wrap text-muted font-weight-bold",
                        tdClass: "no-wrap color-secondary align-middle",
                    },
                    {
                        label: "Action",
                        field: "action",
                        sortable: false,
                        thClass: "table-header no-wrap text-muted font-weight-bold",
                        tdClass: "no-wrap color-secondary align-middle",
                    },
                ],
                rows: [{
                        fullname: 'Jalu',
                        roles: 'Super Admin'
                    },
                    {
                        fullname: 'Jeki',
                        roles: 'Admin'
                    },
                    {
                        fullname: 'Seno',
                        roles: 'Admin'
                    },
                    {
                        fullname: 'Adi',
                        roles: 'User'
                    },
                    {
                        fullname: 'Joni',
                        roles: 'User'
                    }
                ],
            };
        },

        mounted() {
            this.getList();
            this.getRole();
            this.getUser();
        },
        methods: {
            //action
            updateData(props) {
                this.$bvModal.show("modal-1");
                this.isAdd = false;
                // this.modalUpdate = props;
                this.modalUpdate.role_id = props.roles.id
                this.modalUpdate.nik = props.user.nik

                this.id = props.id;
            },

            getList() {
                this.$store.dispatch("role/GET_LIST_DATA", this.body);
            },
            getRole() {
                this.$store.dispatch("role/GET_ROLE");
            },
            getUser() {
                this.$store.dispatch("role/GET_LIST_USER", {
                    page: 1,
                    limit: 1000,
                    company: 'PT. BORNEO INDOBARA'
                });
            },

            saveAdd() {
                this.$validator.validateAll().then(async (res) => {
                    if (!res) return false;
                    try {
                        this.isLoading = true;
                        this.$store
                            .dispatch("role/CREATE_DATA", this.modalCreate)
                            .then((resp) => {
                                this.$swal("Saved", "Your input has been saved", "success").then(
                                    (resp) => {
                                        this.isLoading = false;
                                        (this.modalCreate = {
                                            nik: "",
                                            role_id: "",
                                        }),
                                        this.getList();
                                        this.$bvModal.hide("modal-1");
                                    }
                                );
                            });
                    } catch (error) {
                        this.$swal("Error", "Error while add data", "error");
                    }
                });
            },

            saveUpdate() {
                let body = {
                    // id: this.id,
                    role_id: this.modalUpdate.role_id,
                };
                this.isLoading = true;
                this.$store
                    .dispatch("role/UPDATE_ROLEMANAGEMENT", body)
                    .then((resp) => {
                        this.$swal("Saved", "Your input has been saved", "success").then(
                            (resp) => {
                                this.isLoading = false;
                                (this.modalUpdate = {
                                    nik: "",
                                    role_id: "",
                                }),
                                this.getList();
                                this.$bvModal.hide("modal-1");
                            }
                        );
                    })
                    .catch((err) => {
                        this.isLoading = false
                        this.$swal("Error", "Error while update data", "error");
                    });
            },

            deleteData(id) {
                this.$swal({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#00D97E",
                    cancelButtonColor: "#E63757",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$store
                            .dispatch("role/DELETE_ROLEMANAGEMENT", id)
                            .then((resp) => {
                                this.getList();
                                this.$swal("Deleted!", "Your file has been deleted", "success");
                            })
                            .catch((resp) => {
                                this.$swal("Error", "Error while delete data", "error");
                            });
                    }
                });
            },

            // filter
            filterPage() {},

            sorting() {
                this.getList();
            },

            // Pagination
            onPageChange(payload) {
                this.body.pageSize = payload.currentPerPage;
                this.body.page = payload.currentPage;
                this.getList();
            },

            onSortChange(params) {
                let sort1 = "role";
                let sort2 = params[0].type;
                this.body.field = sort1
                if (sort2 == 'none') {
                    this.body.order = ''
                } else {
                    this.body.order = sort2
                }
                this.getList();
            },
        },
    };
</script>